import { useEffect } from "react";
import { Form, Input, InputNumber, DatePicker, Button } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import "./service-excel.css";

dayjs.extend(customParseFormat);

const parseImportDate = (value) => {
  if (value === null || value === undefined || value === "") return dayjs("");
  if (typeof value === "string" && /^\d{2}\.\d{2}\.\d{4}$/.test(value)) {
    return dayjs(value, "DD.MM.YYYY", true);
  }
  return dayjs(value);
};

const formatImportDate = (value) => {
  const date = parseImportDate(value);
  return date.isValid() ? date.format("YYYY-MM-DD") : null;
};

const importNumber = (value) => {
  if (value === null || value === undefined || value === "") return 0;
  return Number(typeof value === "string" ? value.replace(/\s/g, "").replace(",", ".").replace(/%$/, "") : value);
};

const calculateDebt = (amount, payment) =>
  Number((importNumber(amount) - importNumber(payment)).toFixed(12));

const ServiceExcelSale = ({ record, onSave, onCancel }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (record) {
      const initialValues = {
        ...record,
        activationDate: record.activationDate ? parseImportDate(record.activationDate) : null,
        finishDate: record.finishDate ? parseImportDate(record.finishDate) : null,
        saleDate: record.saleDate ? parseImportDate(record.saleDate) : null,
      };
      form.setFieldsValue(initialValues);
    }
  }, [record, form]);

  const amount = Form.useWatch("amount", form);
  const payment = Form.useWatch("payment", form);

  const handleSave = () => {
    form.validateFields().then(values => {
      const updatedRecord = {
        ...record,
        ...values,
        saleDate: formatImportDate(values.saleDate),
        activationDate: formatImportDate(values.activationDate),
        finishDate: formatImportDate(values.finishDate),
      };
      onSave(updatedRecord);
    }).catch(err => {
      console.error('Validation failed:', err);
    });
  };

  if (!record) return null;

  return (
    <div className="sport-modal">
      <div
        className="sport-modal-overlay"
        onMouseDown={(e) => e.target === e.currentTarget && onCancel()}
      >
        <div
          className="sport-modal-content service-excel-modal-content"
          onMouseDown={(e) => e.stopPropagation()}
        >
          <div className="sport-modal-title">
            <span>Редактирование продажи</span>
            <CloseCircleOutlined
              className="sport-section-title-close"
              onClick={onCancel}
            />
          </div>
          <Form
            form={form}
            layout="vertical"
            colon={false}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Form.Item label="Внешний ID" name="externalId">
              <Input placeholder="Внешний ID" />
            </Form.Item>
            <Form.Item label="Дата продажи" name="saleDate">
              <DatePicker
                className="service-excel-datepicker"
                format="DD.MM.YYYY"
                allowClear
              />
            </Form.Item>
            <Form.Item label="Дата активации" name="activationDate">
              <DatePicker
                className="service-excel-datepicker"
                format="DD.MM.YYYY"
                allowClear
              />
            </Form.Item>
            <Form.Item label="Дата окончания" name="finishDate">
              <DatePicker
                className="service-excel-datepicker"
                format="DD.MM.YYYY"
                allowClear
              />
            </Form.Item>
            <Form.Item label="Сумма" name="amount">
              <InputNumber
                className="service-excel-inputnumber"
                placeholder="Сумма"
                precision={2}
              />
            </Form.Item>
            <Form.Item label="Оплата" name="payment">
              <InputNumber
                className="service-excel-inputnumber"
                placeholder="Оплата"
                precision={2}
              />
            </Form.Item>
            <Form.Item label="Долг" validateStatus={calculateDebt(amount, payment) < 0 ? "error" : undefined}
              help={calculateDebt(amount, payment) < 0 ? "Долг не может быть отрицательным" : undefined}>
              <InputNumber className="service-excel-inputnumber" value={calculateDebt(amount, payment)} readOnly precision={2} />
            </Form.Item>
            <Form.Item label="Скидка" name="discountPrc">
              <InputNumber
                className="service-excel-inputnumber"
                placeholder="Скидка"
                precision={2}
              />
            </Form.Item>
            <Form.Item label="Комментарий" name="comment">
              <Input placeholder="Комментарий" />
            </Form.Item>
            <Form.Item label="Внешний ID клиента" name="clientExternalId">
              <InputNumber
                className="service-excel-inputnumber"
                placeholder="Внешний ID клиента"
              />
            </Form.Item>
            <Form.Item label="Внешний ID абонемента" name="abonementExternalId">
              <InputNumber
                className="service-excel-inputnumber"
                placeholder="Внешний ID абонемента"
              />
            </Form.Item>
            <Form.Item>
              <div className="service-excel-modal-actions">
                <Button onClick={onCancel}>Отмена</Button>
                <Button type="primary" onClick={handleSave}>
                  Сохранить
                </Button>
              </div>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

ServiceExcelSale.displayName = "ServiceExcelSale";

export default ServiceExcelSale;

